export default {
  language_selector: {
    label: 'Sprache wählen',
  },
  nav_items: {
    home: 'Startseite',
    menu: 'Menü',
    locations: 'Standorte',
    store_info: 'Store-Details',
    rewards: 'Prämien',
  },
};
